import React, { Component } from 'react'
import { connect } from "react-redux"
import {addMember } from '../../../../../store/Actions/memberActions/memberActions'
import fbConfig from '../../../../../config/firebaseConfig'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MomentUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers';
import Grid from '@material-ui/core/Grid';
//import DateFnsUtils from '@date-io/date-fns';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import moment from 'moment'
import FormControl from '@material-ui/core/FormControl';
import Modal from '../Modal'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
const uuidv4 = require('uuid/v4');
uuidv4();

const theme = createMuiTheme({
  palette: {
    primary: { main: '#4f8aa5' }
  },
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          background: "$labelcolor"
        }
      }
    }
  }
});

class AddMember extends Component {

  constructor(props){
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      dateOfBirth: null, 
      gender: '',
      trainer:'',
      companyId: '',
      uniqueId: uuidv4(),
      open: false,
      trainers: []
     
    }
  }

 MaxDate(){
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth();
  var day = d.getDate();
  var date = new Date(year - 18, month, day).toLocaleDateString('en-US')
  //console.log("date", date)
    this.setState({
      ...this.state,
      maxDate: date
    })
  
  }

  handleDateChange = date => {
    this.setState({ dateOfBirth: moment(date).add(0, 'days').calendar()});
  };
  handleChange = (e) => {
   this.setState({
     [e.target.name]: e.target.value,
     companyId: this.props.profile.id
   })
  }
  generatePassword() {
    var password = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
      for (var i = 0; i < 9; i++)
      password += possible.charAt(Math.floor(Math.random() * possible.length));
    
     
      this.setState({
        ...this.state,
        password: password
      })
    }
  handleSubmit = e => {
    // e.preventDefault();
    // this.props.addMember(this.state)
    // this.setState({
    //   ...this.state,
    //   open: true
    // })

      this.setState({
        ...this.state,
        loading: true,
        open: true
      })
      let newTrainer = this.state
      const functions = fbConfig.functions();
      const addNewTrainer = functions.httpsCallable('addTrainer');
      addNewTrainer({ email: newTrainer.email,  companyId: this.state.companyId, name: this.state.name, phone: this.state.phone, trainerId: this.state.trainerId, role: this.state.role }).then(result => {
       // console.log(result);
      
        this.setState({
          ...this.state,
          message: result.data.message,
          loading: false
        })
      }).then( ()=> {
        this.props.resetPassword({email:this.state.email})
        this.setState({
          ...this.state,
          messageResset: 'Email send to ' + this.state.email
        })
      })
       .catch(err => {
        //console.log(err);
          this.setState({
            ...this.state,
            message: err.message,
            loading: false
          })
      });
    
  }
  getTrainers = () => {
    let companyId = this.props.profile.companyId
    const db = fbConfig.firestore();
     
    db.collection(companyId).doc('companyUsers').collection('trainers')
    .get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        //console.log(doc)
        let data = doc.data();
        //console.log(data)
        this.setState({
          ...this.state,
          trainers: [...this.state.trainers, data],
        });
        
      });
    });

  }
  resetForm = e =>{
    this.setState({
      name: '',
      email: '',
      dateOfBirth: null,
      gender: '',
      trainer: '',
      open: false,
      uniqueId: uuidv4()
    })
  }
  componentDidMount(){  
    let companyId = this.props.profile.id
    let trainer = this.props.profile.name
     //console.log('add member props', this.props)
    this.setState({
      ...this.state,
      companyId: companyId,
      trainer: trainer,
      open: false
    })
    this.MaxDate()
    this.generatePassword()
    this.getTrainers()
  }
  render() {
   const { dateOfBirth, name, email} = this.state;
   const enabled = name.length > 0 && email.length > 0;
   const { addMemberInfo } = this.props
   console.log('STATE::',this.state)
    var appButtonBg = sessionStorage.getItem('buttonBgColor')|| '#69b4a7'
    var appButtonLink = sessionStorage.getItem('buttonColor')|| '#FFFFFF'
    let trainerList = this.state.trainers.map( trainer => {
       return <MenuItem value={trainer.id} key={trainer.id}>{trainer.name}</MenuItem>
    })
    return (
       <MuiThemeProvider theme={theme} >
       
          <form 
          style={{marginTop: '24px'}}
           onSubmit={this.handleSubmit}
          >
            <TextField
              required
              onChange={this.handleChange}
              style ={{width: '100%',WebkitBoxShadow: '0 0 0 1000px white inset' }}
              name="name"
              label="Client Name"
              value={this.state.name}
            
              margin="normal"
            />
            <MuiPickersUtilsProvider utils={ MomentUtils }  >
                <Grid container>
                  <DatePicker
	                  mode="landscape"
                    style ={{width: '100%', marginTop: '24px'}}
                    margin="normal"
                    label="Date Of Birth"
                    value={dateOfBirth}
                    openToYearSelection={true}
                    onChange={this.handleDateChange}  
                    format="DD MMM YYYY"
                    autoOk={true} 
                    maxDate={this.state.maxDate}
                    helperText="Optional"
                  />
                <FormHelperText></FormHelperText> 
                </Grid>
                
             </MuiPickersUtilsProvider>
             <FormControl style ={{width: '100%', marginTop: '12px'}} >
              <InputLabel htmlFor="gender">Gender</InputLabel>
              <Select
                value={this.state.gender}
                onChange={this.handleChange}
                inputProps={{
                  name: 'gender',
                  id: 'gender',
                }}
              >
                <MenuItem value="">
                  <em>Gender</em>
                </MenuItem>
                <MenuItem value={'men'}>Men</MenuItem>
                <MenuItem value={'women'}>Women</MenuItem>
                <MenuItem value={'other'}>Other</MenuItem>
               </Select>
               <FormHelperText>Optional</FormHelperText> 
              </FormControl>
          
             <TextField
              required
              onChange={this.handleChange}
             // variant="outlined"
              style ={{width: '100%'}}
              name="email"
              label="Member Email"
              value={this.state.email}
              margin="normal"
            />
            <FormControl style ={{width: '100%', marginTop: '24px'}} >
            <InputLabel htmlFor="trainer">Assign Trainer</InputLabel>
              <Select
                value={this.state.trainer}
                onChange={this.handleChange}
                inputProps={{
                  name: 'trainer',
                  id: 'trainer',
                }}
              >
                <MenuItem value="">
                  <em>Assign Trainer</em>
                </MenuItem>
                { trainerList }
               </Select>
              </FormControl>
                 <Button variant="contained" fullWidth  disabled={!enabled} type="submit"  style={{marginTop: '48px',marginBottom: '24px', color:appButtonLink , background:appButtonBg }}>
                     Save Client
                </Button>

          </form>
          
        { addMemberInfo === true & this.state.name !== '' & this.state.open === true ? <Modal open={true} uniqueId={this.state.uniqueId} resetForm={this.resetForm}/> : ''  }
         <div className="info"></div>
        </MuiThemeProvider>
    )
  }
}
const mapStateToProps = (state) => {

  return {
    addMemberInfo: state.memberReducer.AddMember,
    profile: state.firebase.profile  
  }
}
export default connect(mapStateToProps, { addMember })(AddMember)